import store from '@/store'

export default {
  onQuery () {
    return (to, from, next) => {
      let _query = {...to.query}
      store.dispatch(`users/query`, {..._query, limit: 1000, 'filters[where][role][eq]': 'vendedor_dealer'})
        .then(({data}) => {
          next()
        })
        .catch(next)
    }
  }
}



// WEBPACK FOOTER //
// ./src/guards/reassignment.guards.js